export default {
      id: "ic_ag_nav-usage",
      viewBox: "0 0 30 30",
      url: "/" + "images/icons.3.109.2.svg#ic_ag_nav-usage",
      toString: function () {
        return this.url;
      }
    }